import { useEffect, useState } from 'react';

import api from '../../services/api';
import DesignerProjectCard from '../../components/DesignerProjectCard';
import Notification from '../../components/Notification';
import NoProjectsFound from '../../components/NoProjectsFound';
import SelectDropdown from '../../components/SelectDropdown';

import {
  Container,
  Header,
  ProjectsList,
  FilterGroup,
  SelectLabel,
} from './styles';

/* `Em%20análise` já vai codificado porque o valor entra cru na query string. */
const FILTER_OPTIONS = [
  { value: 'Aprovado', label: 'Aprovados' },
  { value: 'Verificar', label: 'Verificar' },
  { value: 'Em%20análise', label: 'Em análise' },
  { value: 'Todos', label: 'Todos' },
];

const DesignerProjects = () => {
  const [projects, setProjects] = useState([]);
  const [hasProjects, setHasProjects] = useState([]);
  const [filter, setFilter] = useState('Todos');
  const [isLoading, setLoading] = useState(true);

  function setProjectsList(data) {
    const projectsList = data.map(p => ({
      ...p,
      createdAt: new Date(p.createdAt).toLocaleDateString({
        locale: 'pt-br',
      }),
    }));
    setProjects(projectsList);
  }

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const { data } = await api.get('/designer_projects');
        setHasProjects(data.length > 0);
        setProjects(
          data.map(p => ({
            ...p,
            createdAt: new Date(p.createdAt).toLocaleDateString('pt-BR'),
          }))
        );
      } catch (err) {
        Notification({
          type: Notification.types.ERROR,
          message: 'Erro ao buscar projetos',
        });
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  async function handleFilterChange(situation) {
    setFilter(situation);
    try {
      setLoading(true);
      const { data } = await api.get(
        `/designer_projects?situation=${situation}`
      );
      setProjectsList(data);
    } catch (err) {
      Notification({
        type: Notification.types.ERROR,
        message: 'Erro ao buscar projetos',
      });
    } finally {
      setLoading(false);
    }
  }

  function renderProjectsList() {
    if (!hasProjects) {
      return (
        <>
          <Header>
            <h1>Meus projetos</h1>
          </Header>

          <NoProjectsFound text="Você ainda não publicou nenhum projeto" />
        </>
      );
    }

    return (
      <>
        <Header>
          <h1>Meus projetos</h1>
          <FilterGroup>
            <SelectLabel>Filtrar por</SelectLabel>
            <SelectDropdown
              variant="box"
              options={FILTER_OPTIONS}
              value={filter}
              onChange={handleFilterChange}
              ariaLabel="Filtrar projetos por situação"
            />
          </FilterGroup>
        </Header>
        {projects.length === 0 ? (
          <NoProjectsFound text="Nenhum projeto encontrado" />
        ) : (
          <ProjectsList>
            {projects.map(p => (
              <DesignerProjectCard key={p.id} project={p} />
            ))}
          </ProjectsList>
        )}
      </>
    );
  }

  return isLoading ? (
    <div className="loader" />
  ) : (
    <Container>{renderProjectsList()}</Container>
  );
};

export default DesignerProjects;
